<template>
  <router-view name="equipment" v-bind:key="$route.path"></router-view>
</template>

<script>
export default {
  name: "Equipment",
};
</script>
